import { render, staticRenderFns } from "./InfoCard.vue?vue&type=template&id=002ba61b&scoped=true&"
import script from "./InfoCard.vue?vue&type=script&lang=ts&setup=true&"
export * from "./InfoCard.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./InfoCard.vue?vue&type=style&index=0&id=002ba61b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002ba61b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('002ba61b')) {
      api.createRecord('002ba61b', component.options)
    } else {
      api.reload('002ba61b', component.options)
    }
    module.hot.accept("./InfoCard.vue?vue&type=template&id=002ba61b&scoped=true&", function () {
      api.rerender('002ba61b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/InfoCard.vue"
export default component.exports